import { writeSettings } from "@/app/actions.mjs";
import { GAME_SHORT_NAMES } from "@/app/constants.mjs";
import type { GamesWithProp, GameSymbol } from "@/app/games.mjs";

export const updateLatestPlayed = (game: GameSymbol) => {
  const shortName: GamesWithProp<"shortName">["shortName"] =
    GAME_SHORT_NAMES[game];
  if (!shortName) return;
  writeSettings(["lastPlayedGames", shortName], Date.now());
};
